import axios from 'axios';

/**
 * Interceptor for successful responses (2xx).
 */
export function AxiosResponseInterceptor(response) {
  return response;
}

/**
 * Interceptor for error responses.
 * If the server returns 500 and we haven't retried yet, we:
 *  1) Refresh the token (using refreshToken from cookies).
 *  2) Update the auth header.
 *  3) Retry the original request once.
 * If the refresh fails or if we've already retried, we reject the error.
 */
export async function AxiosResponseErrorInterceptor(error) {
  if (error.response?.status === 500) {
    console.error(
      '[AXIOS-500] HTTP 500 detected. Skipping cookie mutation and leaving auth state unchanged. URL:',
      error.config?.url,
    );
  } else {
    console.error('Error response:', error.response?.data || error.message);
  }

  return Promise.reject(error);
}
